/* eslint-disable @typescript-eslint/no-explicit-any*/
import React from 'react';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';

const AdvancedCheckbox = ({ value, label, onChange, name, ...props }: any) => {
  return (
    <div className="advanced-checkbox">
      <FormControlLabel
        control={
          <Checkbox
            {...props}
            checked={!!value}
            onChange={(e) => onChange(e.target.checked)}
            name={name}
            color="primary"
          />
        }
        label={label}
      />
    </div>
  );
};

export default AdvancedCheckbox;
